import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthLayout from './AuthLayout';
import InputField from './InputField';
import Button from './Button';
import { MailIcon, ArrowLeftIcon } from 'lucide-react';
const ForgotPasswordPage = ({
  isEmailRegistered,
  setCurrentEmail
}) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [showAccountNotFound, setShowAccountNotFound] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleSubmit = e => {
    e.preventDefault();
    if (!email) {
      setError('Please enter your email address');
      setShowAccountNotFound(false);
      return;
    }
    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      setShowAccountNotFound(false);
      return;
    }
    setLoading(true);
    setError('');
    setShowAccountNotFound(false);
    // Simulate API call to check if email exists
    setTimeout(() => {
      setLoading(false);
      // Check if email is registered in the system
      if (!isEmailRegistered(email)) {
        setShowAccountNotFound(true);
        return;
      }
      // If email exists, proceed to success page
      setCurrentEmail(email);
      navigate('/password-reset-sent', {
        state: {
          email
        }
      });
    }, 1500);
  };
  const handleBackToLogin = () => {
    navigate('/');
  };
  const handleNavigateToRegister = () => {
    navigate('/register');
  };
  return <AuthLayout title="Reset Password" data-id="element-55">
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-56">
        <div className="text-center mb-6" data-id="element-57">
          <p className="text-gray-600" data-id="element-58">
            Enter your email address and we'll send you instructions to reset
            your password.
          </p>
        </div>

        {error && <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-lg" data-id="element-59">
            <div className="flex" data-id="element-60">
              <div className="flex-shrink-0" data-id="element-61">
                <svg className="h-5 w-5 text-red-500" viewBox="0 0 20 20" fill="currentColor" data-id="element-62">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" data-id="element-63" />
                </svg>
              </div>
              <div className="ml-3" data-id="element-64">
                <p className="text-sm text-red-700" data-id="element-65">{error}</p>
              </div>
            </div>
          </div>}

        {showAccountNotFound && <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-lg" data-id="element-66">
            <div className="flex" data-id="element-67">
              <div className="flex-shrink-0" data-id="element-68">
                <svg className="h-5 w-5 text-red-500" viewBox="0 0 20 20" fill="currentColor" data-id="element-69">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" data-id="element-70" />
                </svg>
              </div>
              <div className="ml-3" data-id="element-71">
                <p className="text-sm text-red-700" data-id="element-72">
                  No account found with this email address. Please check your
                  email or{' '}
                  <button type="button" onClick={handleNavigateToRegister} className="font-medium text-blue-600 hover:text-blue-800 underline" data-id="element-73">
                    create a new account
                  </button>
                  .
                </p>
              </div>
            </div>
          </div>}

        <div className="relative" data-id="element-74">
          <InputField label="Email address" type="email" name="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" data-id="element-75" />
          <div className="absolute right-4 top-3.5" data-id="element-76">
            <MailIcon size={20} className="text-blue-400" data-id="element-77" />
          </div>
        </div>

        <div className="pt-3" data-id="element-78">
          <Button type="submit" fullWidth loading={loading} data-id="element-79">
            Send Reset Instructions
          </Button>
        </div>

        <div className="text-center pt-2" data-id="element-80">
          <button type="button" onClick={handleBackToLogin} className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium transition-colors" data-id="element-81">
            <ArrowLeftIcon size={16} className="mr-2" data-id="element-82" />
            Back to sign in
          </button>
        </div>
      </form>
    </AuthLayout>;
};
export default ForgotPasswordPage;